import {useSelector} from "react-redux";
import {RootSliceType} from "redux/reducers/rootReducer";
import {IPurchase} from "../reducers/purchaseSlice";

export const usePurchaseSelector = () => {
  const pointsPlanToPurchase = useSelector<RootSliceType,
    IPurchase["pointsPlanToPurchase"]>((state) => state.purchase.pointsPlanToPurchase);
  const pointsPlans = useSelector<RootSliceType,
    IPurchase["pointsPlans"]>((state) => state.purchase.pointsPlans);
  const loading = useSelector<RootSliceType,
    IPurchase["loading"]>((state) => state.purchase.loading);
  return {
    pointsPlanToPurchase,
    pointsPlans,
    loading
  };
};

export default usePurchaseSelector;